import React from 'react'
import { DialogContent } from '@common/material'
import { RegisterItemDetails } from '@modules/registers/items/RegisterItemDetails'
import { ModalDialogContainer } from '@common/modal'
import { RegisterFilterScopes } from '../types'

type RegisterItemDetailsModalProps = {
  registerItemId: number
  registerId: number
  registerViewId?: number
  scope: RegisterFilterScopes
  initialTabColumnId?: string
}

export const RegisterItemDetailsModal: React.FC<
  RegisterItemDetailsModalProps
> = (props) => {
  return (
    <ModalDialogContainer maxWidth='lg'>
      <DialogContent
        sx={{
          overflow: 'auto',
          height: '100vh',
          flexDirection: 'column',
          my: '20px',
          py: 0,
        }}
      >
        <RegisterItemDetails {...props} isModal />
      </DialogContent>
    </ModalDialogContainer>
  )
}
